import React from 'react';

/*
 *  @Description:   Stateless component that renders a tickets icon.
 */

const Tickets = ( props ) => {

    return (<g id="path">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
            <rect transform="rotate(-90)" x="-17" y="7.5" width="3" height="9"/>
            <rect transform="rotate(-90)" x="-10" y="7.5" width="3" height="5"/>
        </g>
    )
};

export default Tickets;

